/* import __COLOCATED_TEMPLATE__ from './confirm-delete.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();